import { SharedPrizeCarousel } from 'components/prize-carousel/SharedPrizeCarousel';
import { homepagePrizeCarouselItems } from 'constants/Prizes';

export const PrizeCarousel = (props: { variant?: 'HomePage2026Variant' }) => {
  return (
    <SharedPrizeCarousel
      items={homepagePrizeCarouselItems}
      textPosition="default"
      overlayVariant="gradient"
      showButtonsOnMobile={false}
      showButtonsOnDesktop={true}
      desktopInlinePadding="40px"
      slidePadding="var(--dm2025-gap-8)"
      variant={
        props.variant === 'HomePage2026Variant'
          ? 'HomePage2026Variant'
          : undefined
      }
    />
  );
};
